import React, { Fragment, useEffect, useState } from 'react'
// import PropTypes from 'prop-types'
// import { connect } from 'umi'
// import { Helmet } from 'react-helmet'
// import { Loader } from 'components'
import { queryLayout } from 'utils'
// import NProgress from 'nprogress'
import config from 'utils/config'
import { withRouter } from 'react-router'

import PublicLayout from './PublicLayout'
import DoctorLayout from './DoctorLayout'
import './BaseLayout.module.scss'
import BreadCrumbLayout from './BreadCrumbLayout'
import { enquireScreen, unenquireScreen } from 'enquire-js'
import { RootState } from 'store'
import { connect } from 'react-redux'
import { Wrapper } from 'components'
import MobileLayout from './MobileLayout'
import PublicMobileLayout from './PublicMobileLayout'

const LayoutMap = {
  doctor: DoctorLayout,
  public: PublicLayout,
  breadCrumb: BreadCrumbLayout,
  noContainer: Wrapper,
  mobileLayout: MobileLayout,
  publicMobileLayout: PublicMobileLayout,
}


const BaseLayout = (props) => {
  let previousPath = ''

  const [isMobile, setisMobile] = useState(false)

  const { loading, children, location, account, isAuthenticated } = props
  const Container = LayoutMap[queryLayout(config.layouts, location.pathname)]


  useEffect(() => {
    const enquireHandler = enquireScreen(mobile => {
      // const { isMobile } = this.state
      if (isMobile !== mobile) {
        // this.setState({
        //   isMobile: mobile,
        // })
        setisMobile(mobile)
      }
    })
    return () => {
      unenquireScreen(enquireHandler)
    }
  }, [])

  const currentPath = location.pathname + location.search
  if (currentPath !== previousPath) {
    // NProgress.start()
  }

  // if (!loading.global) {
  //   NProgress.done()
  //   previousPath = currentPath
  // }

  return (
    <Fragment>
      {/* <Helmet>
          <title>{config.siteName}</title>
        </Helmet> */}
      {/* <Loader fullScreen spinning={loading.effects['app/query']} /> */}
      <Container
        location={location}
        isMobile={isMobile}
        account={account}
        isAuthenticated={isAuthenticated}>{children}</Container>
    </Fragment>
  )
}

const mapStateToProps = ({ authentication }: RootState) => ({
  isAuthenticated: authentication.isAuthenticated,
  account: authentication.account,
});


// export default withRouter(PublicLayout)
export default connect(mapStateToProps, null)(withRouter(BaseLayout));
